/* Block - Team.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */

/* eslint-disable-next-line */
import styles from './block-team.scss';
import rsCarousel from '../../js/component/_carousel-team';

const carousels = Array.from(document.querySelectorAll('body:not(.wp-admin) .rs-team-carousel'));

rsCarousel.init(carousels);
